import { API } from "aws-amplify";

export const GET_EVENTS_LIST_REQUEST = "@@event/GET_EVENTS_LIST_REQUEST";
export const GET_EVENTS_LIST_SUCCESS = "@@event/GET_EVENTS_LIST_SUCCESS";
export const GET_EVENTS_LIST_FAILURE = "@@event/GET_EVENTS_LIST_FAILURE";

export function getEventsList() {
  return async (dispatch) => {
    dispatch({
      type: GET_EVENTS_LIST_REQUEST,
    });
    try {
      let url = "/event";
      const response = await API.get("cmsAPI", url);
      dispatch({
        type: GET_EVENTS_LIST_SUCCESS,
        payload: response,
      });
    } catch (error) {
      dispatch({
        type: GET_EVENTS_LIST_FAILURE,
        payload: error,
      });
    }
  };
}
